import {
  LOCAL_STORAGE_ACTIVE_STEP_KEY,
  LOCAL_STORAGE_ACTIVE_TOUR_KEY,
} from '../../../constants/localeStorageConts'
import { TourType } from '../types'

const getTourCompletedKey = (tourType: TourType): string => `joyride-${tourType}-tour-completed`

export const getActiveTourStateFromStorage = (): { type: TourType | null; step: number } => {
  const type = localStorage.getItem(LOCAL_STORAGE_ACTIVE_TOUR_KEY) as TourType | null
  const stepStr = localStorage.getItem(LOCAL_STORAGE_ACTIVE_STEP_KEY)
  const step = stepStr ? parseInt(stepStr, 10) : 0
  return { type, step: !isNaN(step) ? step : 0 }
}

export const setActiveTourStateInStorage = (type: TourType, step: number): void => {
  localStorage.setItem(LOCAL_STORAGE_ACTIVE_TOUR_KEY, type)
  localStorage.setItem(LOCAL_STORAGE_ACTIVE_STEP_KEY, String(step))
}

export const clearActiveTourStateFromStorage = (): void => {
  localStorage.removeItem(LOCAL_STORAGE_ACTIVE_TOUR_KEY)
  localStorage.removeItem(LOCAL_STORAGE_ACTIVE_STEP_KEY)
}

export const markTourCompletedInStorage = (type: TourType): void => {
  localStorage.setItem(getTourCompletedKey(type), 'true')
}

export const isTourCompletedInStorage = (type: TourType): boolean => {
  return !!localStorage.getItem(getTourCompletedKey(type))
}
